/** @format */

import { FormItemType } from "@/psychlab/types/form";
// import { SessionsListFilters } from "@/components.generic/sessions-list-with-filters/types";

const translations = {
	analytics: {
		formsData: {
			title: "Forms data",
			fieldTypes: {
				[FormItemType.Answer]: "Answer",
				[FormItemType.Checkboxes]: "Checkbox",
				[FormItemType.LinearScale]: "Linear scale",
				[FormItemType.MultipleChoice]: "Multiple choices",
				[FormItemType.Dropdown]: "Dropdown",
				[FormItemType.HTML]: "HTML",
				[FormItemType.Information]: "Information",
			},
		},
	},
	// filters: {
	// 	[SessionsListFilters.SESSIONS_FROM]: "Session from",
	// 	[SessionsListFilters.SESSIONS_TO]: "Session to",
	// 	[SessionsListFilters.PROGRESS]: "Progress",
	// 	[SessionsListFilters.FINISHED]: "Finished",
	// 	[SessionsListFilters.LABELS]: "Labels",
	// },
};

export default translations;
